import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from '../styles/ForgetPasswordPage.module.css';
import videoBackground from '../styles/background.mp4';

const ForgetPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
const [isForgetPasswordMenuOpen, setIsForgetPasswordMenuOpen] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/api';
      await axios.post(`${apiUrl}/forgot-password`, { email });
      setMessage('A password reset link has been sent to your email.');
    } catch (err) {
      console.error('Error sending reset password email:', err);
      setError('Failed to send reset email. Please try again.');
    }
  };

  return (
    <div className={styles.forgetPasswordPage}>
       <video className={styles.ForgetPasswordPageVideoBackground} autoPlay loop muted>
              <source src={videoBackground} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
<header className={styles.ForgetPasswordPageheaderMenu}>
  <div onClick={() => navigate('/')} className={styles.ForgetPasswordPagelogo}>
    Full Trucking Service
  </div>

  <div className={styles.hamburgerForgetPassword} onClick={() => setIsForgetPasswordMenuOpen(!isForgetPasswordMenuOpen)}>
    ☰
  </div>

  <nav className={`${styles.navMenuForgetPassword} ${isForgetPasswordMenuOpen ? styles.activeForgetPassword : ''}`}>
    <ul>
      <li onClick={() => navigate('/about')}>About Us</li>
      <li onClick={() => navigate('/services')}>Services</li>
      <li onClick={() => navigate('/contact')}>Contact</li>
      <li onClick={() => navigate('/pricing')}>Register</li>
    </ul>
  </nav>
</header>

      <h1 className={styles.titleforgetPasswordPage}>Forget Password</h1>
      <form onSubmit={handleSubmit} className={styles.formforgetPasswordPage}>
        <div className={styles.formGroupforgetPasswordPage}>
          <label>Email:</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={styles.inputforgetPasswordPage} />
        </div>
        <button type="submit" className={styles.buttonforgetPasswordPage}>Submit</button>
      </form>
      {message && <p className={styles.ForgetPasswordPagesuccessMessage}>{message}</p>}
      {error && <p className={styles.ForgetPasswordPageerrorMessage}>{error}</p>}
    </div>
  );
};

export default ForgetPasswordPage;
